import React from "react";
import { Link } from "react-router-dom";
import * as CHQ from "chq";

import { ProfileLink } from "app/links";
import { t, Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type PhotoTaggedNotificationProps = {
  notification: CHQ.NotificationPhotoTagged;
  tabIndex?: number;
};

const PhotoTaggedNotification: React.FC<PhotoTaggedNotificationProps> = ({
  notification: { actor, entity: { photo } }, tabIndex
}) => (
  <NotificationBody actor={actor}>
    <ProfileLink user={actor} tabIndex={tabIndex || 0} />
    {" "}
    <Trans>tagged you in a photo!</Trans>
    <Link to={`/photos/${photo.id}`} tabIndex={tabIndex || 0}>
      <img
        className="img-preview"
        src={photo.image.mediumUrl}
        alt={photo.caption || t("Tagged photo")}
      />
    </Link>
  </NotificationBody>
);

export default PhotoTaggedNotification;
